(function () {
  'use strict';

  var K_CITY = 'mk_city';
  var K_AREA = 'mk_area';
  var PROMPT = 'Choose your city to see prices';
  var CITY = window.MK_CITY || {};
  /* Site language is set by the owner (Theme settings > Language). 'ta' shows Tamil for every city
     (cities that already speak Tamil keep their own wording); 'city' follows each city's own language. */
  /* Default: each city's own greeting, spelled in English letters only (no Kannada, Tamil or Telugu script). */
  if (window.MK_LANG_LATIN) {
    var EN = {
      Bengaluru: { hello: 'Hello', ask: 'Have you had your meal?' },
      Chennai: { hello: 'Hello', ask: 'Have you eaten?' },
      Coimbatore: { hello: 'Welcome', ask: 'Have you eaten?' },
      Mysuru: { hello: 'Hello', ask: 'Have you had your meal?' },
      Hyderabad: { hello: 'Hello', ask: 'Have you had your meal?' }
    };
    document.documentElement.setAttribute('data-latin', '');
    Object.keys(CITY).forEach(function (k) {
      var c = CITY[k], en = EN[k] || { hello: 'Hello', ask: '' };
      var q = function (t) { return '“' + t + '”'; };
      c.lang = 'en';
      c.hello = q(c.helloLatin); c.helloLatin = en.hello;
      c.ask = q(c.askLatin.split('? ')[0] + '?'); c.askLatin = en.ask;
      c.thanks = q(c.thanksLatin); c.thanksLatin = 'Thank you';
      c.fresh = ''; c.native = ''; c.dishScript = '';
    });
  }
  var PACK = window.MK_LANG_PACK || null;
  if (PACK) {
    Object.keys(CITY).forEach(function (k) {
      var c = CITY[k];
      if (c.lang !== PACK.lang) {
        var over = c[PACK.lang] || {};
        Object.keys(PACK).forEach(function (f) { c[f] = PACK[f]; });
        Object.keys(over).forEach(function (f) { c[f] = over[f]; });
      }
    });
  }
  var NAMES = window.MK_PRODUCTS || {};

  function lsGet(k) { try { return window.localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function lsSet(k, v) {
    try { window.localStorage.setItem(k, v); } catch (e) {}
    document.cookie = k + '=' + encodeURIComponent(v) + ';path=/;max-age=31536000;SameSite=Lax';
  }
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var state = { city: lsGet(K_CITY), area: lsGet(K_AREA) };
  var pendingCity = '';
  var modal = qs('#mk-modal');
  var busy = false;
  var toastTimer = null;

  /* ---------- location ---------- */
  function areaButtons(city) {
    return qsa('#mk-areas [data-area]').filter(function (b) { return b.getAttribute('data-area-city') === city; });
  }
  function needsArea(city) { return areaButtons(city).length > 0; }
  function complete() { return !!state.city && (!needsArea(state.city) || !!state.area); }
  function label() {
    if (!state.city) { return 'Choose city'; }
    return state.city + (state.area ? ' · ' + state.area : '');
  }
  function sortByOrder(container) {
    if (!container) { return; }
    var els = qsa('[data-order]', container);
    els.sort(function (a, b) { return (+a.getAttribute('data-order')) - (+b.getAttribute('data-order')); });
    els.forEach(function (e) { container.appendChild(e); });
  }

  function toast(msg) {
    var t = qs('#mk-toast');
    if (!t) { return; }
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 3200);
  }

  function showStep(step, city) {
    qs('#mk-step-city').hidden = step !== 'city';
    qs('#mk-step-area').hidden = step !== 'area';
    if (step === 'area') {
      qs('#mk-area-city').textContent = city;
      qsa('#mk-areas [data-area]').forEach(function (b) { b.hidden = b.getAttribute('data-area-city') !== city; });
    }
    qsa('#mk-cities [data-city]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-city') === state.city)); });
  }
  function openModal(forceCityStep) {
    if (!modal) { return; }
    modal.hidden = false;
    document.body.classList.add('mk-lock');
    var needArea = !forceCityStep && state.city && needsArea(state.city) && !state.area;
    if (needArea) { pendingCity = state.city; }
    showStep(needArea ? 'area' : 'city', state.city);
    qs('#mk-close').hidden = !complete();
    var first = qs('.chip:not([hidden])', modal);
    if (first) { first.focus(); }
  }
  function closeModal() {
    if (!modal) { return; }
    modal.hidden = true;
    document.body.classList.remove('mk-lock');
  }
  function choose(city, area) {
    var changed = city !== state.city;
    state.city = city;
    state.area = area || '';
    lsSet(K_CITY, state.city);
    lsSet(K_AREA, state.area);
    closeModal();
    render();
    syncCart();
    if (changed && CITY[city]) { toast([CITY[city].hello, CITY[city].helloLatin].filter(Boolean).join(' · ') + ', ' + city); }
  }
  function pickCity(city) {
    if (needsArea(city)) {
      pendingCity = city;
      showStep('area', city);
      var first = qs('#mk-areas .chip:not([hidden])');
      if (first) { first.focus(); }
    } else {
      choose(city, '');
    }
  }

  /* ---------- city vernacular layer ---------- */
  function cityFx() {
    var d = CITY[state.city], root = document.documentElement;
    root.toggleAttribute('data-has-city', !!d);
    qsa('[data-fx-on]').forEach(function (e) { e.hidden = !d; });
    qsa('[data-fx-off]').forEach(function (e) { e.hidden = !!d; });
    if (!d) { root.style.removeProperty('--city'); root.removeAttribute('data-city'); return; }
    root.style.setProperty('--city', d.accent);
    root.setAttribute('data-city', state.city);
    ['hello', 'helloLatin', 'native', 'fresh', 'ask', 'askLatin', 'dishScript', 'dish', 'dishNote', 'heritage', 'heritageNote'].forEach(function (k) {
      qsa('[data-fx="' + k + '"]').forEach(function (e) { e.textContent = d[k] || ''; });
    });
    qsa('[data-fx="city"]').forEach(function (e) { e.textContent = state.city; });
    qsa('[data-fx-script]').forEach(function (e) { e.setAttribute('lang', d.lang); });
    qsa('[data-fx-sep]').forEach(function (e) { e.hidden = !d.native || !d.helloLatin; });
    qsa('[data-fx-hide-empty]').forEach(function (e) { e.hidden = !e.textContent.replace(/[\s·]/g, ''); });
    qsa('[data-fx-bg]').forEach(function (img) {
      if (d.full && img.getAttribute('src') !== d.full) { img.src = d.full; }
      img.alt = '';
    });
    qsa('[data-fx-art]').forEach(function (img) {
      if (img.getAttribute('src') !== d.art) { img.src = d.art; }
      img.alt = 'Illustration of ' + state.city;
    });
    qsa('[data-fx-dish]').forEach(function (img) {
      if (img.getAttribute('src') !== d.dishImg) { img.src = d.dishImg; }
      img.alt = d.dish;
    });
    qsa('[data-fx-credit]').forEach(function (a) {
      a.textContent = d.credit || '';
      if (d.creditUrl) { a.href = d.creditUrl; } else { a.removeAttribute('href'); }
      a.parentNode.hidden = !d.credit;
    });
    qsa('[data-fx="pairs"]').forEach(function (e) {
      e.innerHTML = '';
      d.pairs.forEach(function (h) {
        var a = document.createElement('a');
        a.className = 'pair';
        a.href = '/products/' + h;
        a.textContent = (NAMES[h] || h) + ' →';
        e.appendChild(a);
      });
    });
  }

  /* ---------- prices ---------- */
  function variantsOf(el) {
    var s = qs('.mk-variants', el);
    try { return JSON.parse(s.textContent); } catch (e) { return []; }
  }
  function variantFor(el) {
    if (!state.city) { return null; }
    var list = variantsOf(el);
    for (var i = 0; i < list.length; i++) { if (list[i].city === state.city) { return list[i]; } }
    return null;
  }
  function renderProduct(el) {
    var p = qs('.mk-price', el), cmp = qs('.mk-compare', el), b = qs('.mk-add', el);
    if (!p || !b) { return; }
    var round = b.classList.contains('add');
    if (!state.city) {
      p.textContent = PROMPT; p.classList.add('prompt');
      cmp.hidden = true; b.disabled = false;
      if (!round) { b.textContent = 'Add to cart'; }
      return;
    }
    var v = variantFor(el);
    p.classList.remove('prompt');
    if (!v) {
      p.textContent = 'Not available in ' + state.city;
      p.classList.add('prompt');
      cmp.hidden = true; b.disabled = true;
      if (!round) { b.textContent = 'Unavailable'; }
      return;
    }
    p.textContent = v.price;
    if (v.compare) { cmp.textContent = v.compare; cmp.hidden = false; } else { cmp.hidden = true; }
    b.disabled = !v.available;
    if (!round) { b.textContent = v.available ? 'Add to cart' : 'Sold out'; }
  }
  function render() {
    qsa('[data-mk-label]').forEach(function (e) { e.textContent = label(); });
    qsa('[data-mk-city]').forEach(function (e) { e.textContent = state.city || 'your city'; });
    qsa('[data-product]').forEach(renderProduct);
    qsa('input[name="attributes[City]"]').forEach(function (i) { i.value = state.city; });
    qsa('input[name="attributes[Delivery area]"]').forEach(function (i) { i.value = state.area; });
    cityFx();
  }

  /* ---------- cart ---------- */
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.json(); });
  }
  function setCount(n) { qsa('[data-mk-count]').forEach(function (e) { e.textContent = n; }); }
  function saveAttrs() { return post('/cart/update.js', { attributes: { 'City': state.city, 'Delivery area': state.area } }); }

  /* ---------- delivery, packing and cutting: Rs 70 x every started kilo.
     Kept out of the cart; added only as the customer leaves for checkout, so it is part of the amount paid on Razorpay. ---------- */
  var FEE = 'delivery-packing-cutting', feeProduct = null;
  function isFee(i) { return i.handle === FEE; }
  function feeQty(cart) { return cart.items.filter(isFee).reduce(function (s, i) { return s + i.quantity; }, 0); }
  function goodsCount(cart) { return cart.item_count - feeQty(cart); }
  function getFeeProduct() {
    if (feeProduct) { return Promise.resolve(feeProduct); }
    return fetch('/products/' + FEE + '.js').then(function (r) { return r.json(); }).then(function (p) { feeProduct = p; return p; });
  }
  function syncFee(cart, forCheckout) {
    if (!state.city) { return Promise.resolve({ cart: cart, changed: false }); }
    var grams = cart.items.filter(function (i) { return !isFee(i); }).reduce(function (s, i) { return s + (i.grams || 0) * i.quantity; }, 0);
    var kg = forCheckout && grams > 0 ? Math.ceil(grams / 1000 - 1e-9) : 0;
    return getFeeProduct().then(function (p) {
      var v = p.variants.filter(function (x) { return x.option1 === state.city; })[0];
      if (!v) { return { cart: cart, changed: false }; }
      var updates = {}, changed = false, have = 0;
      cart.items.filter(isFee).forEach(function (i) {
        if (i.variant_id === v.id) { have += i.quantity; } else { updates[i.variant_id] = 0; changed = true; }
      });
      if (have !== kg) { updates[v.id] = kg; changed = true; }
      if (!changed) { return { cart: cart, changed: false }; }
      return post('/cart/update.js', { updates: updates }).then(function (c) { return { cart: c, changed: true }; });
    }).catch(function (err) {
      if (forCheckout) { throw err; }
      return { cart: cart, changed: false };
    });
  }
  function reprice(cart) {
    var lookups = cart.items.map(function (i) {
      return fetch('/products/' + i.handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var v = p.variants.filter(function (x) { return x.option1 === state.city && x.available; })[0];
        return v ? { id: v.id, quantity: i.quantity } : null;
      });
    });
    return Promise.all(lookups).then(function (items) {
      var ok = items.filter(Boolean), dropped = items.length - ok.length;
      return post('/cart/clear.js', {})
        .then(function () { return ok.length ? post('/cart/add.js', { items: ok }) : null; })
        .then(saveAttrs)
        .then(syncFee)
        .then(function (res) {
          var c = res.cart;
          setCount(goodsCount(c));
          toast(dropped ? 'Cart updated to ' + state.city + ' prices. ' + dropped + ' item(s) not available there were removed.' : 'Cart updated to ' + state.city + ' prices.');
          if (/\/cart/.test(location.pathname)) { location.reload(); }
        });
    });
  }
  function syncCart() {
    if (busy) { return Promise.resolve(); }
    busy = true;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(goodsCount(cart));
        if (!complete() || !cart.items.length) { return null; }
        var mismatch = cart.items.some(function (i) { return i.variant_options && i.variant_options[0] !== state.city; });
        if (mismatch) { return reprice(cart); }
        var a = cart.attributes || {};
        var attrs = (a['City'] !== state.city || (a['Delivery area'] || '') !== state.area) ? saveAttrs() : Promise.resolve(cart);
        return attrs.then(syncFee).then(function (res) {
          setCount(goodsCount(res.cart));
          if (res.changed && /\/cart/.test(location.pathname)) { location.reload(); }
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  function addToCart(el, btn) {
    if (!complete()) { openModal(false); return; }
    var v = variantFor(el);
    if (!v || !v.available) { return; }
    var qEl = qs('.mk-qty', el);
    var q = qEl ? Math.max(1, parseInt(qEl.value, 10) || 1) : 1;
    var round = btn.classList.contains('add');
    btn.disabled = true;
    post('/cart/add.js', { items: [{ id: v.id, quantity: q }] })
      .then(saveAttrs)
      .then(syncFee)
      .then(function (res) {
        setCount(goodsCount(res.cart));
        btn.textContent = round ? '✓' : 'Added';
        var d = CITY[state.city];
        toast('Added to your cart' + (d && d.thanks ? ' · ' + d.thanks + (d.thanksLatin ? ' (' + d.thanksLatin + ')' : '') : ''));
        setTimeout(function () { if (round) { btn.textContent = '+'; } renderProduct(el); }, 1300);
      })
      .catch(function () { renderProduct(el); if (round) { btn.textContent = '+'; } toast('Could not add that. Please try again.'); });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var add = t.closest('.mk-add');
    if (add) { addToCart(add.closest('[data-product]'), add); return; }
    if (t.closest('[data-mk-open]')) { openModal(true); return; }
    var pick = t.closest('[data-mk-pick-city]');
    if (pick) { openModal(true); pickCity(pick.getAttribute('data-mk-pick-city')); return; }
    var cityBtn = t.closest('#mk-cities [data-city]');
    if (cityBtn) { pickCity(cityBtn.getAttribute('data-city')); return; }
    var areaBtn = t.closest('#mk-areas [data-area]');
    if (areaBtn) { choose(pendingCity || state.city, areaBtn.getAttribute('data-area')); return; }
    if (t.closest('#mk-back')) { showStep('city'); return; }
    if (t.closest('#mk-close')) { closeModal(); return; }
    var qb = t.closest('[data-q]');
    if (qb) {
      var input = qs('.mk-qty', qb.closest('.qty'));
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(qb.getAttribute('data-q'), 10));
      return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden && complete()) { closeModal(); }
  });
  if (modal) { modal.addEventListener('click', function (e) { if (e.target === modal && complete()) { closeModal(); } }); }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest ? e.target.closest('[data-mk-cart-form]') : null;
    if (!f) { return; }
    if (!complete()) { e.preventDefault(); openModal(false); return; }
    render();
    e.preventDefault();
    var btn = f.querySelector('[name="checkout"]');
    if (btn) { btn.disabled = true; }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return saveAttrs(); })
      .then(function (c) { return syncFee(c, true); })
      .then(function () { location.href = '/checkout'; })
      .catch(function () {
        if (btn) { btn.disabled = false; }
        toast('Could not open checkout. Please try again.');
      });
  });
  /* back from checkout: the page comes from the browser cache, so clear the fee again */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) { return; }
    qsa('[name="checkout"]').forEach(function (b) { b.disabled = false; });
    syncCart();
  });

  /* ---------- init ---------- */
  sortByOrder(qs('#mk-cities'));
  sortByOrder(qs('#mk-areas'));
  render();
  if (!complete()) { openModal(false); }
  syncCart();

  /* product page gallery */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.pdp__thumb');
    if (!t) { return; }
    var media = t.closest('.pdp__media'), main = media && media.querySelector('.pdp__img img');
    if (!main) { return; }
    main.src = t.getAttribute('data-src');
    main.removeAttribute('srcset');
    media.querySelectorAll('.pdp__thumb').forEach(function (b) { b.classList.toggle('is-on', b === t); b.removeAttribute('aria-current'); });
    t.setAttribute('aria-current', 'true');
  });
})();
